import { IconInfoCircleFilled } from '@tabler/icons-react';

export default function DetallesWhite({ onClick, grow = false }) {
  if (grow) {
    return (
      <button
        onClick={onClick}
        className="font-semibold flex items-center justify-center gap-2 h-12 px-4 rounded-full whitespace-nowrap transition-all duration-200 ease-out active:scale-[0.98] hover:bg-white/10 flex-1 min-w-0"
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.06)',
          border: 'none',
          cursor: 'pointer',
          color: 'rgba(255, 255, 255, 0.92)',
          fontSize: '13px',
          fontFamily: '"Public Sans", sans-serif',
          letterSpacing: '-0.01em',
          minWidth: 'max-content',
        }}
      >
        Detalles
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Ver detalles"
      title="Ver detalles"
      className="flex items-center justify-center shrink-0 w-12 h-12 rounded-full border-none cursor-pointer touch-manipulation select-none transition-all duration-200 ease-out active:scale-[0.96] [@media(hover:hover)]:hover:bg-white/10"
      style={{ backgroundColor: 'rgba(255, 255, 255, 0.06)' }}
    >
      <IconInfoCircleFilled size={18} color="rgba(255, 255, 255, 0.92)" />
    </button>
  );
}